import { Translate } from '@/utils/hooks/translation/useTranslation';

import { languages_available } from '@/lib/settings/optionsConfiguration/platformSettings/languagesAvailable';
import {
    beginning_q1,
    date_format,
    enable_monthly_digest_email,
    enable_notifications,
    enable_weekly_digest_email,
    export_csv_delimiter,
    first_day_week,
    homepage,
    numbers_format,
    platform_language,
    time_format,
    validate_auto_publishing_mobile_app
} from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';
import { timezone } from '@/lib/settings/optionsConfiguration/platformSettings/timezone';

export function getPlatformSettingsOptions(t: Translate) {
    return {
        platform_language: platform_language(t),
        posts_auto_translate: languages_available(t),
        homepage: homepage(t),
        export_csv_delimiter: export_csv_delimiter(t),
        validate_auto_publishing_mobile_app: validate_auto_publishing_mobile_app(t),
        enable_notifications: enable_notifications(t),
        media_automatic_conversion: enable_notifications(t),
        timezone,
        numbers_format: numbers_format(t),
        time_format: time_format(t),
        date_format: date_format(t),
        first_day_week: first_day_week(t),
        beginning_q1: beginning_q1(t),
        enable_weekly_digest_email: enable_weekly_digest_email(t),
        enable_monthly_digest_email: enable_monthly_digest_email(t)
    };
}
